export type GeometricFormType = 'mitra-vertex' | 'mitra-edge' | 'mitra-building' | 'mitra-building-border';

export enum GeometricFormTypeEnum {
  VERTEX = 'mitra-vertex',
  EDGE = 'mitra-edge',
  BUILDING = 'mitra-building',
  BUILDING_BORDER = 'mitra-building-border',
}
